var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'my-box': _vm.speaker === 'my', 'other-box': _vm.speaker === 'other' }},[(!_vm.isDemo || !_vm.isDemoEditScenario || _vm.speaker === 'my')?_c('p',{staticClass:"message",style:({
      background: _vm.speaker === 'my' ? _vm.color.balloonMy : _vm.color.balloonOtr + '!important',
      color: _vm.autoColor(_vm.speaker === 'my' ? _vm.color.balloonMy : _vm.color.balloonOtr),
      filter: _vm.shadowStyle(_vm.color.shadowType),
    }),domProps:{"innerHTML":_vm._s(
      _vm.$sanitize(_vm.convertMesasge(_vm.message, _vm.speaker === 'my' ? _vm.color.balloonMy : _vm.color.balloonOtr))
    )}}):(!_vm.isConfirm)?_c('textarea',{staticClass:"textarea message-title",domProps:{"value":_vm.$sanitize(
        _vm.convertMesasge(_vm.originalMessage, _vm.speaker === 'my' ? _vm.color.balloonMy : _vm.color.balloonOtr)
      )},on:{"blur":function($event){_vm.oldValue = _vm.$sanitize(
        _vm.convertMesasge(_vm.originalMessage, _vm.speaker === 'my' ? _vm.color.balloonMy : _vm.color.balloonOtr)
      )
      _vm.updateMainMessage($event.target.value, _vm.oldValue, _vm.logIndex)}}}):_c('textarea',{staticClass:"textarea message-title",attrs:{"disabled":""},domProps:{"value":_vm.$sanitize(
        _vm.convertMesasge(_vm.originalMessage, _vm.speaker === 'my' ? _vm.color.balloonMy : _vm.color.balloonOtr)
      )}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ec653d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BalloonParts/MessageParts.vue
// module id = null
// module chunks = 